import styled from 'styled-components';
import { RadioGroupSwitcher } from '@landlord-tech/ui-kit-opp';

const SRadioGroupSwitcher = styled(RadioGroupSwitcher)`
  &&& {
  }
`;

export default SRadioGroupSwitcher;
